import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, Heading, Instructions, ExternalLinkBlock } from '../s'
import Paragraph from 'components/typography/paragraph'
import Link from 'components/link'

const TeamtailorHowToUse = ({ data }) => {
    const { formatMessage } = useIntl()

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_heading_how_to_use"
                    defaultMessage="How to use" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_teamtailor_preamble_how_to_use"
                    defaultMessage="Get started quickly by following these 3 steps:" />
            </Paragraph>
            <Instructions instructions={[
                {
                    text: formatMessage({
                        id: 'integration_teamtailor_instruction_connect',
                        defaultMessage: 'Click the [%key:integration_action_configure%] button and accept Huma’s Terms and Conditions. You will be provided with an <accent>ID</accent>, <accent>Client ID</accent> and a <accent>Client secret</accent>.'
                    }, { accent: accentuate })
                },
                {
                    text: formatMessage({
                        id: 'integration_teamtailor_instruction_activate',
                        defaultMessage: 'Go to <link>HumaHR</link> in Teamtailor’s marketplace and activate it.'
                    }, {
                        link: chunks => (
                            <Link
                                href={data.marketplaceUrl}
                                target="_blank"
                                className="constructive">
                                {chunks}
                            </Link>
                        )
                    })
                },
                {
                    text: formatMessage({
                        id: 'integration_teamtailor_instruction_add_keys',
                        defaultMessage: 'Find HumaHR in your Teamtailor settings and add the <accent>Client ID</accent> and <accent>Client secret</accent>.'
                    }, { accent: accentuate })
                },
                {
                    text: formatMessage({
                        id: 'integration_teamtailor_instruction_create_api_key',
                        defaultMessage: 'Create an API key in Teamtailor settings.'
                    })
                }
            ]} />
            <ExternalLinkBlock href={data.knowledgebaseUrl}>
                <FormattedMessage
                    id="integration_teamtailor_link_knowledgebase"
                    defaultMessage="Using the Teamtailor integration" />
            </ExternalLinkBlock>
        </Section>
    )
}

export default TeamtailorHowToUse